<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-autocomplete
                                                label="Delivered Sales Invoice"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="sale_delivery_master_id.value.value"
                                                :items="deliveredSalesInvoiceList"
                                                :item-title="(item) => `${item.code}`"
                                                item-value="id"
                                                @update:modelValue="onPurchaseOrderChange"
                                                :error-messages="sale_delivery_master_id.errorMessage.value"
                                                autocomplete="off"
                                                @keyup="getDeliveredSalesInvoiceList($event.target.value)"
                                                clearable
                                            >
                                                <template #label>
                                                    Delivered Sales Invoice
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Warehouse"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Warehouse
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Customer Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="customer_id.value.value"
                                                :items="getCustomerList"
                                                :item-title="(item) => `${item.company_name}`"
                                                item-value="id"
                                                :error-messages="customer_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Customer Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input
                                                label="Return Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="return_date.value.value"
                                                :error-messages="return_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>

                                            <v-text-field
                                                label="Rfq By"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by.value.value"
                                                :error-messages="purOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Rfq By Mobile"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by_mobile.value.value"
                                                :error-messages="purOrder_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Rfq By Email"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="purOrder_by_email.value.value"
                                                :error-messages="purOrder_by_email.errorMessage.value"
                                                :disabled="true"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Item Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pt-2 justify-center d-none">
                                        <v-col cols="8">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                autocomplete="off"
                                                @update:model-value="addCart"
                                                @keydown.enter="addCart"
                                                clearable
                                            ></v-autocomplete>

                                            <input
                                                v-model="sale_delivery_master_id.value.value"
                                                type="hidden"
                                            />
                                        </v-col>

                                        <!-- <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col> -->
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                        <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-left" style="width: 25%">
                                                        Product Name
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                        Received Qty
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                            Returnable Qty
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                        Return Qty
                                                        </th>
                                                        <th class="text-center" style="width: 15%">Unit</th>
                                                        <th class="text-right" style="width: 15%">Rate</th>
                                                        <th class="text-right" style="width: 15%">Sub Total</th>
                                                        <th class="text-center" style="width: 10%">
                                                        Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in cart"
                                                        v-if="cart.length > 0"
                                                        :key="index"
                                                    >
                                                        <td class="text-center py-1">{{ index + 1 }}</td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                        {{ item.product_name }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                        {{ item.qty }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                        {{ item.returnable_qty}}
                                                        </td>
                                                        <td class="text-right py-1">
                                                        <v-text-field
                                                            :reverse="false"
                                                            controlVariant="stacked"
                                                            label=""
                                                            :hideInput="false"
                                                            :inset="false"
                                                            :min="1"
                                                            type="number"
                                                            style="width: 80px"
                                                            density="compact"
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="item.qty_for_return"
                                                           :error-messages="
                                                                item.qty_for_return < 1
                                                                    ? 'Quantity must be greater than 0'
                                                                    : (item.qty_for_return > item.returnable_qty
                                                                        ? 'Quantity cannot exceed Returnable Qty'
                                                                        : '')
                                                            "
                                                            @update:model-value="
                                                            item.amount = item.qty_for_return * item.rate
                                                            "
                                                            @blur="item.amount = item.qty_for_return * item.rate"
                                                        ></v-text-field>
                                                        </td>
                                                        <td class="text-center py-1">
                                                        {{ item.unit_name }}
                                                        </td>
                                                        <td class="text-right py-1">
                                                        {{ this.$numberFormat(item.rate) }}
                                                        </td>
                                                        <td class="text-right py-1">
                                                        {{ this.$numberFormat(item.amount) }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                        <v-icon
                                                            size="small"
                                                            color="red"
                                                            class="delete-button"
                                                            @click="removeFromCart(index)"
                                                        >
                                                            mdi-delete
                                                        </v-icon>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                        <v-skeleton-loader
                                                            type="heading"
                                                            :loading="loading"
                                                        />
                                                        </td>
                                                    </tr>
                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                        You have no item
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Description"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                              <v-btn
                                                  class="bg-grey-darken-1 me-2"
                                                  variant="flat"
                                                  @click="submitForm(0)"
                                                  >DRAFT</v-btn
                                              >
                                              <v-btn
                                                  class="bg-primary"
                                                  variant="flat"
                                                  @click="submitForm(1)"
                                                  >POST</v-btn
                                              >
                                            </v-layout>
                                        </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    selectedImage: null,
    photo_imageFile: "",
    preview: "/src/assets/no_preview.png",
    cart: [],
    types: [
      { id: 1, name: "Normal" },
      { id: 2, name: "Urgent" },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
    if (this.$store.getters.getCustomerList.length === 0) {
      this.$store.dispatch("getCustomerList");
    }
    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }

    if (this.$store.getters.deliveredSalesInvoiceList.length === 0) {
      this.$store.dispatch("deliveredSalesInvoiceList");
    }
  },
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getCustomerList() {
      return this.$store.getters.getCustomerList;
    },
    deliveredSalesInvoiceList() {
      const requisitions = this.$store.getters.deliveredSalesInvoiceList || [];
      return requisitions.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
  },
  methods: {
    getDeliveredSalesInvoiceList(searchText){
      if (!searchText || searchText.length < 4) {return;}
      this.$store.dispatch("deliveredSalesInvoiceList", {code:searchText});
    },
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );
      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }
      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.id == this.product_id.value.value
      );
      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_name: product.name,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        rate: product.purchase_rate,
        total: product.purchase_rate,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.product_id.value.value = null;
    },
    async onPurchaseOrderChange(selectedId) {
      if (!selectedId) {
        this.warehouse_id.value.value = null;
        this.type_id.value.value = null;
        this.cart = [];
        return;
      }

      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        const data = await this.$store.dispatch(
          "getInvSalesInvoiceDeliveryById",
          selectedId
        );

        this.warehouse_id.value.value = data.warehouse_id || data.warehouse?.id || null;
        this.customer_id.value.value = data?.invoice_master?.customer_id;
        this.return_date.value.value = data.return_date
          ? new Date(data.return_date)
          : null;
        this.remarks.value.value = data.remarks || "";
        this.po_master_id.value.value = data.id || null;

        this.cart = [];
        const orderDetails = data.invoice_delivery_details || [];
        orderDetails.forEach((item) => {
          this.cart.push({
            sale_delivery_details_id:item.id,
            product_id: item.product_id,
            product_name: item.product?.name || "",
            qty: item.qty,
            returnable_qty: item.qty - item.return_qty,
            qty_for_return: item.qty - item.return_qty,
            unit_id: item.product?.unit_id || item.product?.unit?.id || "",
            unit_name: item.product?.unit?.name || "",
            rate: item.rate,
            total: item.returnable_qty * item.rate,
            amount: (item.qty_for_return??(item.qty - item.return_qty))  * item.rate,
          });
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.error("Failed to load requisition data:", error);
      }
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        return_date: yup.date().required().label("Return Date"),
        warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
        sale_delivery_master_id: yup.number().positive().integer().required().label("Received Purchase Order"),
        customer_id: yup.number().positive().integer().required().label("Supplier Name"),
      }),
    });
    
    const sales_return_master_id = useField("sales_return_master_id");
    const po_master_id = useField("po_master_id");
    const product_id = useField("product_id");
    const pr_status = useField("pr_status");
    const employee_id = useField("employee_id");
    const warehouse_id = useField("warehouse_id");
    const customer_id = useField("customer_id");
    const sale_delivery_master_id = useField("sale_delivery_master_id");
    const return_date = useField("return_date");
    const remarks = useField("remarks");
    const purOrder_by = useField("purOrder_by");
    const purOrder_by_mobile = useField("purOrder_by_mobile");
    const purOrder_by_email = useField("purOrder_by_email");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      console.log(values);
      values.status = currentStatus.value;
      values.cart = cart.value;
      values.return_date = formattedDate(return_date.value.value);

      store
        .dispatch("saveUpdateSalesReturn", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "sales-return-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      sales_return_master_id,
      product_id,
      return_date,
      remarks,
      cart,
      purOrder_by,
      purOrder_by_mobile,
      purOrder_by_email,
      pr_status,
      errorMessages,
      employee_id,
      warehouse_id,
      po_master_id,
      customer_id,
      sale_delivery_master_id,
      buttonText,
      loading,
    };
  },

  mounted() {
    this.pr_status.value.value = "1";
    this.employee_id.value.value = "";
    let user = this.$store.getters.getAuthUser;
    this.purOrder_by.value.value = user.full_name;
    this.purOrder_by_mobile.value.value = user.mobile;
    this.purOrder_by_email.value.value = user.email;

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("salesReturnDetails", {sales_return_master_id: id})
          .then((data) => {
            this.isEntryMode = false;
            let purOrder = data.data.data;
            this.sales_return_master_id.value.value = purOrder.id;
            this.sale_delivery_master_id.value.value = purOrder.sale_delivery_master_id;
            this.return_date.value.value = purOrder.return_date
              ? new Date(purOrder.return_date)
              : new Date();
            this.warehouse_id.value.value = purOrder.warehouse.id;
            this.product_id.value.value = null;
            this.customer_id.value.value = purOrder.customer_id;
            this.cart.value = [];

            // Insert items one by one
            (purOrder.details || []).forEach((item) => {
              // this.cart.push({
              //   product_id: item.product_id,
              //   product_name: item.product?.name || "",
              //   qty: item.qty,
              //   unit_id: item.product.unit?.id || "",
              //   unit_name: item.product.unit?.name || "",
              //   rate: item.rate,
              //   total: item.qty * item.rate,
              // });

              this.cart.push({
                sale_delivery_details_id:item?.sale_delivery_details_id,
                sales_return_details_id:item.id,
                product_id: item.product_id,
                product_name: item.product?.name || "",
                qty: item?.sales_invoice_details?.qty,
                returnable_qty: ((item?.sales_invoice_details?.qty??0) - (item?.sales_invoice_details?.return_qty??0) + item.qty),
                qty_for_return: item.qty,
                unit_id: item.product?.unit_id || item.product?.unit?.id || "",
                unit_name: item.product?.unit?.name || "",
                rate: item.rate,
                total: item.returnable_qty * item.rate,
                amount: item.qty * item.rate,
              });
            });
            this.remarks.value.value = purOrder.remarks ? purOrder.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch rfq:", error);
          });
      });
    } else {
      this.return_date.value.value = new Date();
      this.isEntryMode = true;
    }
  },
};
</script>
